import { ApiConcept, ApiConceptQuery, ApiMultiConceptResponse } from 'types/swagger/clarifai-api';
import { fetchApi } from 'utils/request';

export type ConceptRequest = {
  request: {
    userOrOrgId: string;
    appId: string;
  };
  concept: ApiConcept;
  onlyCurrentAppConcepts?: boolean;
};

export const postConcept = async ({
  request: { userOrOrgId, appId },
  concept,
}: Omit<ConceptRequest, 'onlyCurrentAppConcepts'>): Promise<ApiConcept | null> => {
  const response = await fetchApi<ApiMultiConceptResponse>({
    path: `/api/_api/v2/users/${userOrOrgId}/apps/${appId}/concepts`,
    method: 'POST',
    body: {
      concepts: [concept],
    } as ApiConceptQuery,
  });
  // TODO: types/swagger/clarifai-api.ts has INVALID status.code, which is a STRING?? But BE returns a number!
  // Therefore a hack for it below (as unknown as number) :/
  if (response?.status?.code && (response.status.code as unknown as number) === 10000 && response.concepts && response.concepts.length) {
    return response.concepts[0];
  }
  return null;
};
